/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { string } from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';

import { trackEvent } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { setSearchV3DrawerOpened } from '../../../../../state/ducks/App/App-Actions';
import { getFeatureFlag } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const useStyles = makeStyles((theme) => ({
    search: {
        display: 'flex',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: 10,
        lineHeight: '12px',
        textTransform: 'capitalize',
        textAlign: 'center',
        textDecoration: 'none',
        color: theme.palette.cms?.mobileMenuTextColor || theme.palette.mobileMenuColor,
        marginTop: '3px',
        fontFamily: 'var(--comp-base-font-family-default, Lato , Helvetica, Arial, sans-serif)',
    },
    searchMain: {
        width: 40,
        height: '100%',
        gridRow: 1,
        gridColumn: 2,
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

const MobileSearch = ({ imageUrl, title }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const mobileIconsWithoutTextEnabled = useSelector(getFeatureFlag('is-mobile-icons-without-text'));

    const handleClick = () => {
        dispatch(trackEvent({
            eventCategory: 'MobileSearchIcon',
            eventAction: 'Clicked Search',
            eventLabel: title,
        }));
        dispatch(setSearchV3DrawerOpened(true));
    };

    return (
        <>
            <div
                className={classes.searchMain}
                onClick={handleClick}
                role="presentation"
                id="searchButton"
            >
                <span className={classes.container}>
                    <img src={imageUrl} alt="Search Icon" aria-hidden="true" role="presentation" width="24" height="24" />
                    {!mobileIconsWithoutTextEnabled && (
                        <span className={classes.search}>
                            {title}
                        </span>
                    )}
                </span>
            </div>
        </>
    );
};

MobileSearch.defaultProps = {
    imageUrl: '',
    title: '',
};

MobileSearch.propTypes = {
    imageUrl: string,
    title: string,
};

export default MobileSearch;
